<template>
    <div class="main">
      <div class="notice-bar" v-if="params.acid == 919">
        <van-notice-bar
            left-icon="volume-o"
            color="#ffffff" background="rgba(0,0,0,.3)"
            text="抽奖红包到账可能会有1到3天左右的延迟，请用户完成抽奖后耐心等待"
        />
      </div>

        <div class="header">
            <div class="title"></div>
            <div class="way">
                <p>剩余抽奖次数：{{freeNum}}</p>
            </div>
        </div>
        <div class="luck-area">
            <ul id="lis">
                <div :class="{light1:true, lighting: lightUp}"></div>
                <div :class="{light2:true, lighting: !lightUp}"></div>
                <li :class="{active:active == 1}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[0] && list[0].title" :src="!!list[0] && list[0].img_url">
                    </div>
                </li>
                <li :class="{active:active == 2}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[1] && list[1].title" :src="!!list[1] && list[1].img_url">
                    </div>
                </li>
                <li :class="{active:active == 3}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[2] && list[2].title" :src="!!list[2] && list[2].img_url">
                    </div>
                </li>
                <li :class="{active:active == 8}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[7] && list[7].title" :src="!!list[7] && list[7].img_url">
                    </div>
                </li>
                <li class="btn">
                    <button type="button" id="val" :disabled="btn_disabled" @click="is_free()">
                        <img src="~assets/img/luck/btn.png">
                    </button>
                </li>
                <li :class="{active:active == 4}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[3] && list[3].title" :src="!!list[3] && list[3].img_url">
                    </div>
                </li>
                <li :class="{active:active == 7}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[6] && list[6].title" :src="!!list[6] && list[6].img_url">
                    </div>
                </li>
                <li :class="{active:active == 6}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[5] && list[5].title" :src="!!list[5] && list[5].img_url">
                    </div>
                </li>
                <li :class="{active:active == 5}">
                    <div class="res"></div>
                    <div>
                        <div class="li-mask"></div>
                        <img :alt="!!list[4] && list[4].title" :src="!!list[4] && list[4].img_url">
                    </div>
                </li>
            </ul>
            <div class="shadow"></div>
        </div>
        <div class="btn-area">
            <button @click="go_my_draw()">我的奖品</button>
            <button @click="show_rule = true">规则说明</button>
        </div>
        <div class="luck-list">
            <div class="top"></div>
            <div class="list">
                <div class="list-title">中奖名单</div>
                <ul :style="`margin-top:${marginTop}*2rem`">
                    <li v-for="(item, i) in luckList" :key="item.id" :class="{odd:i%2 == 0}">
                        <span>{{item.nickname}}</span>
                        <span>{{item.jname}}</span>
                        <span>{{item.create_time | date}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <transition name="succeed">
            <div v-show="succeed" class="succeed">
                <div class="mask" @click="succeed=false"></div>
                <div class="box">
                    <div v-if="current.type != 0" class="success-title">恭喜获得</div>
                    <div v-else class="success-title"></div>
                    <div v-if="current.type != 0" class="prize">
                        {{current.title}}
                    </div>
                    <div v-else class="prize"></div>
                    <div>
                        <img :src="current.img_url">
                    </div>
                    <div>
                        <div v-if="current.type==2" style="margin:.1rem;color:#393940;font-size: .28rem;">
                            积分稍后会发放<br>请至您的个人中心查看
                        </div>
                        <div v-else-if="current.type==4" style="margin:.1rem;color:#393940;font-size: .28rem;">
                            奖金稍后会发放至您的微信账户<br>请注意微信的服务通知，及时领取红包过期作废
                        </div>
                        <div v-else-if="current.type==3" style="margin:.1rem;color:#393940;font-size: .28rem;">
                            奖券已发放<br>请在抽奖页面【我的奖品】中查看
                        </div>
                        <div v-else-if="current.type==6" style="margin:.1rem;color:#393940;font-size: .28rem;">
                            请至抽奖页面【我的奖品】查看<br>并到现场领取实物
                        </div>
                        <div v-else-if="current.type==1" style="margin:.1rem;color:#393940;font-size: .28rem;">
                            请在抽奖页面【我的奖品】中查看<br>并填写您的收货地址
                        </div>
                        <button @click="succeed=false">确 定</button>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="succeed">
            <div v-show="show_rule" class="succeed">
                <div class="mask" @click="show_rule=false"></div>
                <div class="box">
                    <div class="rule-title">活动规则</div>
                    <div class="rule" v-html="rule"></div>
                </div>
            </div>
        </transition>
    </div>
</template>
<style lang="less" scoped>
    @import './index.less';
</style>
<script>
import { NoticeBar } from 'vant';
    export default {
      components: {
        VanNoticeBar: NoticeBar
      },
        mounted() {
            setInterval(() => {
                this.lightUp = !this.lightUp;
            }, 300);
            this.$api.user.getUserInfo().then((res)=>{
                this.userInfo = res.data
            })
            this.read_winList();
            this.read_prize_list();
        },
        data() {
            return {
                userInfo:"",
                marginTop: 0,
                luckId: this.luck_id,
                active: 1,
                timer: function () {
                },
                timer2: function () {
                },
                time: 0,
                x: 0,
                nam: 0,
                current: {
                    title: ""
                },
                list: [],
                luckList: [],
                btn_disabled: false,
                succeed: false,
                clear: false,
                freeNum: 0,
                lightUp: true,
                show_rule: false,
                params: this.$route.params,
                rule: "",
                alert: false,
                drawpoint: ""
            };
        },
        methods: {
            go_my_draw() {
                wx.miniProgram.navigateTo({
                    url: `/store/pages/myluckdraw/index?acid=${this.params.acid}`
                });

            },

            read_prize_list() {
                this.$api.activity.activityDetail(this.params).then(r => {
                    this.list = r.data.list;
                    this.freeNum = r.data.freenum;
                    this.rule = r.data.activity.description;
                    this.drawpoint = r.data.drawpoint
                });
            },

            read_winList() {
                this.$api.activity.winList({acid: this.params.acid}).then(r => {
                    this.luckList = r.data;

                    if (!!this.luckList && this.luckList.length >= 10) {
                        setInterval(() => {
                            this.marginTop -= 0.01;
                            if (this.marginTop < -0.88) {
                                this.marginTop = 0;
                                let item = this.luckList.splice(0, 4);
                                this.luckList = this.luckList.concat(item);
                            }
                        }, 100);
                    }
                });
            },

            start() {
                this.nam = 0;
                this.timer = setInterval(this.fun, this.time);
            },

            // 抽奖循环
            fun() {
                this.nam += 1;

                if (this.nam >= 16 + this.luckId - 4) {
                    // 模拟减速过程
                    this.time = (4 - (this.luckId - this.x)) * 200;

                    clearInterval(this.timer);

                    if (this.x != this.luckId) {
                        this.timer = setInterval(this.fun, this.time);
                    } else if (this.x == this.luckId) {
                        clearInterval(this.timer);

                        if (this.current.type != 0) this.read_winList();

                        this.$api.activity.activityDetail(this.params).then(r => {
                            if (r.status == 200) {
                                this.freeNum = r.data.freenum;
                                this.btn_disabled = false;
                                this.succeed = true;
                            } else {
                                this.$vuex.alert.show({
                                    title: "提示",
                                    content: r.message
                                });
                            }
                        });
                    }

                    this.x++;
                }
                this.active++;
                if (this.active > 8) this.active = 1;
            },

            findNameById(id) {
                return this.list.find(item => {
                    return item.id == id;
                });
            },
            // 点击按钮开始的抽奖动画
            fun2() {
                if (this.clear && this.active == 8) {
                    clearInterval(this.timer2);
                    this.start();
                }

                this.active++;
                if (this.active > 8) this.active = 1;
            },

            is_free() {
                if(this.btn_disabled)
                  return
                var that = this;
                this.$api.user.getUserInfo().then((res)=>{


                    // let {name,phone} = res.data
                    // if(!name || !phone){
                    //     this.$dialog.confirm({
                    //         title: '提示',
                    //         message: `为了便于奖品发放,请补全您的真实姓名和手机号`,
                    //     }).then(() => {
                    //         wx.miniProgram.navigateTo({
                    //             url: `/pages/user/bindphone/index`
                    //         });
                    //     }).catch(() => {
                    //     });
                    //     return ;
                    // }



                    that.btn_disabled = true;
                    that.clear = false;
                    that.$api.activity.activityDetail(that.params).then(re => {
                        if (re.status != 200) {
                            this.$vuex.alert.show({
                                title: "提示",
                                content: re.message
                            });
                            that.btn_disabled = false;
                        }
                        that.freeNum = re.data.freenum;

                        // let that = this;

                        if (that.freeNum == 0 && !that.alert) {
                          if(this.drawpoint*1>0){
                            this.$dialog.confirm({
                              title: '免费次数已用完',
                              message: `您的免费次数已用完，接下来的每次抽奖将花费${that.drawpoint}积分。`,
                            }).then(() => {
                              that.alert = true;
                              that.get_luck_id();
                            }).catch(() => {
                              that.btn_disabled = false;
                            });
                          }else{
                            that.$dialog.confirm({
                              showCancelButton:false,
                              title: '抽奖次数已用完',
                              message: `您的抽奖次数已用完`,
                            }).then((res)=>{
                              that.alert = false;
                              that.btn_disabled = false;

                            })
                          }





                        } else {
                            that.get_luck_id();
                        }
                    });




                })


            },
            get_luck_id() {
                this.time = 200;
                this.timer2 = setInterval(this.fun2, this.time);

                // 设置抽奖模式 0. 免费 1. 10币
                if (this.freeNum != 0) {
                    this.params.method = 0;
                } else {
                    this.params.method = 1;
                }

                // fetch("activity/drawonce", this.params)
                this.$api.activity.drawonce(this.params)
                    .then(r => {
                        if (r.status != 200) {

                            this.$dialog.alert({
                                title: "提示",
                                message: r.message
                            })


                            clearInterval(this.timer2);
                            this.active = 1;
                            this.btn_disabled = false;
                            return;
                        }

                        this.current = r.data;
                        let id = r.data.id;

                        this.luckId =
                            this.list.findIndex(function (row) {
                                return row.id == id;
                            }) + 1;

                        this.x = this.luckId - 3;
                        this.clear = true;
                    })
                    .catch(() => {

                        this.$dialog.alert({
                            title: "提示",
                            message: "网络连接错误，请检查网络后再试。"
                        })
                        clearInterval(this.timer2);
                        this.active = 1;
                        this.btn_disabled = false;
                        return;
                    });
            }
        }
    };
</script>
